import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthContext.jsx'

// Landing page: hero + auth CTA. Everything else was scoped out.

export function Home() {
  const { t } = useTranslation()
  const { user } = useAuth()

  return (
    <>
      <section className="hero">
        <div className="hero-inner">
          <h1>{t('home.hero_title')}</h1>
          <p className="hero-sub">{t('home.hero_sub')}</p>
          <div className="hero-cta">
            {user ? (
              <Link to="/settings/participants" className="button">
                {t('nav.participants')}
              </Link>
            ) : (
              <Link to="/login" className="button">{t('nav.login')}</Link>
            )}
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <p>{t('common.app_name')}</p>
      </footer>
    </>
  )
}
